<template>
  <v-container>
    <v-container>
      <v-row>
        <v-col offset-md="2">
          <h2>Update Hour Data</h2>
          <router-link to="/admin">Back to Admin</router-link>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="4" sm="6" xs="12" offset-md="2">
          <v-select
            v-model="hourSelected"
            :items="hourRange()"
            @change="loadHour(hourSelected)"
            label="Hour #"
            outlined
            append-outer-icon="mdi-minus-circle"
            @click:append-outer="loadHour(null)"
          ></v-select>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="!!hour">
      <v-row>
        <v-col md="2" sm="3" xs="4" offset-md="2">
          <v-text-field
            :value="hour.hourNumber"
            label="Hour Number"
            outlined
            disabled></v-text-field>
        </v-col>
        <v-col md="2" sm="3" xs="4">
          <v-text-field
            :value="hour.createdBy"
            label="Created By"
            outlined
            disabled></v-text-field>
        </v-col>
        <v-col md="2" sm="3" xs="4">
          <v-switch
            :value="hour.speedRound"
            label="Speed Round"
            color="warning"
            disabled></v-switch>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="3" sm="4" xs="6" offset-md="2">
          <v-text-field
            v-model="hour.kvscPointTotal"
            label="KVSC Points"
            outlined></v-text-field>
        </v-col>
        <v-col md="3" sm="4" xs="6">
          <v-text-field
            v-model="hour.kvscRank"
            label="KVSC Rank"
            outlined></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="3" sm="4" xs="6" offset-md="2">
          <v-text-field
            v-model="teamAhead"
            label="Team Ahead (Points)"
            outlined></v-text-field>
        </v-col>
        <v-col md="3" sm="4" xs="6">
          <v-text-field
            v-model="teamBehind"
            label="Team Behind (Points)"
            outlined></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" xs="12" offset="2">
          <v-btn
            large
            color="success"
            @click="saveHour(hourKey, hour)">
            Save
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbarColor">
      {{ snackbarMessage }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { range } from 'lodash'

export default {
  name: 'HourAdmin',
  data: () => ({
    hour: null,
    hourDetail: null,
    hourSelected: null,
    hourKey: null,
    teamBehind: 0,
    teamAhead: 0,
    snackbar: false,
    snackbarMessage: '',
    snackbarColor: 'success',
  }),
  computed: {
    latestHour: function () {
      return this.$store.getters['hours/getLatestHour']()
    },
  },
  mounted: async function () {
    await this.$store.dispatch('hours/bindHours')
  },
  methods: {
    saveDetail: function (property, value) {
      this.$store.commit('hours/updateHourDetail', { property, value: parseInt(value) })
    },
    hourRange: function () {
      return range(1, this.latestHour + 1)
    },
    loadHour: function (hourNumber) {
      if (hourNumber) {
        const hourDetail = this.$store.getters['hours/getHourDetail'](hourNumber)
        const hourKey = this.$store.getters['hours/getHourKey'](hourNumber)
        const teamAhead = hourDetail.kvscPointTotal + hourDetail.ptsToNext
        const teamBehind = hourDetail.kvscPointTotal - hourDetail.ptsFromPrev

        this.hour = { ...hourDetail }
        this.hourKey = hourKey
        this.teamAhead = teamAhead
        this.teamBehind = teamBehind
      } else {
        this.hour = null
        this.hourKey = null
        this.teamAhead = 0
        this.teamBehind = 0
      }
    },
    saveHour: function (key, hour) {
      const updatedHour = {
        ...hour,
        ptsToNext: parseInt(this.teamAhead) - hour.kvscPointTotal,
        ptsFromPrev: hour.kvscPointTotal - parseInt(this.teamBehind),
      }
      this.$store.dispatch('hours/updateHour', { key, hour: updatedHour }).then(() => {
        this.snackbarMessage = 'Hour update successful!'
        this.snackbarColor = 'success'
        this.snackbar = true
      }).catch((error) => {
        this.snackbarMessage = `Error: ${error.message}`
        this.snackbarColor = 'Error saving hour update please try again.'
        this.snackbar = true
      })
    },
  },
}
</script>

<style scoped>

</style>
